<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>침입자에게는 문 너머가 없다</p></div>
            <div class="content">
 이리에와 나는 2학년에 이어 3학년도 같은 반이었다. 서면으로 공지된 것을 옆에서 확인하자마자 걔가 나에게 고개를 돌렸다. 농담하는 기색도 없이 뻔뻔하게 말했다.
<br>
<br>
“좋겠다. 선우.”
<br>
<br>
“너 진짜 웃기는 애다.”
<br>
<br>
나는 우리의 위 아래로 나열된 같은 반 친구들의 이름을 손가락으로 훑으며 대답했다. 그러다가 1학년 때 복도가 소란하게 싸웠던 그 2호와 3호의 이름이 이번년도에도 한 반에 겹치지 않는 것을 확인했다. 역시 선생님들 귀에도 들어갔던 모양이었다. 
<br>
<br>
“나는 좋은데.”
<br>
<br>
“잠깐 사이에 인간이 왜 이렇게 됐지? 1학년 때는 우리 학교 전설의 고래 아니었냐.”
<br>
<br>
텀블러에 따뜻한 물을 받을 때, 그 하얀 수증기 안의 섬세한 옆얼굴. 소문과 결부되어 더욱 의뭉스레 보였던 눈과 입술이 떠올랐다. 고래를 구경거리 삼고 있는 걸 티내지 않으려는 나의 시선처리에 걔가 뒤를 돌아봤던 일도. 
<br>
<br>
김이리에는 내가 벽보를 다 읽을 때까지 기다려줬다. 사람들을 조금씩 헤치며 그와 함께 복도를 걸어 나왔다. 등 뒤로 탄식이나 환호가 들렸다. 결국 다들 적응하게 될 것이다. 원하지 않는 환경에서도 살아가는 일 말이다.
<br>
<br>
“그런 거 유효기간 끝났어. 내가 아주 큰 상을 받거나, 아주 큰 범죄를 저지르기 전까지는.”
<br>
<br>
꽤 영리하고 시니컬한 어조였다. 그렇다. 언론은 범죄자나 위인의 특수성을 조명한다. 사람들에게는 그가 그렇게 될 수밖에 없었던 이유가 필요하다. 좋은 실적이든, 나쁜 행적이든 뚜렷한 원인과 결과를 알고 싶어 한다. 인과응보 없이 삶의 변수와 별난 일들을 감당하기란, 사람들에게 두려움만 더한다.
<br>
<br>
“둘 중에 뭐 할 건데.”
<br>
<br>
“둘 다 해볼까? 어떻게 되든 네가 내 가장 친한 친구로서 인터뷰하겠네.”
<br>
<br>
“김이리에는 확실히. 말이 안 통하는 인간이었습니다.”
<br>
<br>
“좋아. 어떤 언론사에서도 널 시시하게 여기지 못하겠는걸.”
<br>
<br>
너의 재정에 보탬이 된다면 내 얘기를 조금은 팔아먹어도 돼. 아직 일반인인 김이리에가 의연하게 대답했다. 아주 흰소리는 아닌 것 같아서 일순간 마음에 피가 돌 듯이 뜨끈했다. 너무 속물적인 구석에서 솔깃했나. 그렇다고 해도, 누군가 나의 복지를 신경 써주는 건 나에게 세상에 존재할 명분을 주는 일이었다. 자유의지로 움직이는 인간 하나가 나를 특정해서 불행하지 않기를 바라고 있다. 자기를 약간 이용해먹어도 된다는 허락과 함께. 속고 싶은 기적과도 같았다.

<br>
<br>
<br>
<br>
“남의 꿈에 입장하는 건 피곤한 일이야.”
<br>
<br>
막 3학년이 된 봄이었다. 학교 운동장의 그네를 타고 있었다. 4월의 바람은 세상의 많은 것들을 용서하게 했다. 겨울에는 자연현상마저 사람을 못살게 군다. 바깥을 가만히 걸을만한 자비를 베풀지 않는다. 몸을 뻣뻣이 굳히고 움츠린 채 각자의 동굴로 돌아가게 한다. 비로소 봄이 되어서야 나는 세상에게 환영받는 기분이 든다. 대지가 조금 더 관대해지는 시기라고도 할 수 있겠다. 
<br>
<br>
해질녘이라 다소 쌀쌀했으나 그네로 바람을 가르는 일 정도는 괜찮다. 이 그네에는 나름의 사연이 있다. 이것은 음향원의 ‘통촉그네’라고 불린다. 음향원 초기 선배들이 설치해놓고 간 것이다. 그 당시 가을 축제에서 ‘통촉하여주시옵소서’라는 이벤트를 했다고 한다. 학생들이 학교에 바라는 바를 적어놓은 소원 수리함을 전달하는 학생회 주최 행사였다. 그 해에 두 개의 소원이 이루어졌다. 
<br>
<br>
<br>
<br>

음향원 학생들의 동심을 위해 그네와 미끄럼틀을 설치해주세요
<br>
<br>
<br>
<br>


일주일동안 매일 점심식사 후 호텔급 디저트 제공
<br>
<br>
<br>
<br>

두 번째의 실행 결과는 내가 목격할 길이 없지만, 음향원장과 교육부 담당자의 상의 끝에 이 두 가지가 이루어졌다. 그네도 미끄럼틀도 설치 초기에는 방과 후에 줄을 서서 탔다고 한다. 물론 학교 밖에도 놀이터나 공원은 무수하지만, 기숙사생들에게는 멀었다. 무엇보다 청소년들에게는 학교 안에서 해야만 의미 있는 헛짓거리가 있다.
<br>
<br>
남의 꿈에 입장하는 건 피곤한 일이야. 4월 기온으로 유순해진 나에게 이리에는 그런 얘기를 털어놓았다. 흘러들어오기만 하면 남의 악몽에도 거절할 수 없이 끌려 들어간다는 사연이었다. 장소와 연계되어 반복되는 꿈은 누군가에게 트라우마를 남긴 공간인 경우가 많다. 걔가 가장 무서웠다는 공간으로는 <span class="sound_text_visited" :class="{'sound-text' : visited[32] === 'disabled'}" @click="play('저수지')">저수지</span>와 <span class="sound_text_visited" :class="{'sound-text' : visited[33] === 'disabled'}" @click="play('엘리베이터')">엘리베이터</span>가 있다.
<br>
<br>
남의 꿈에 진입하게 되면, 김이리에는 그 장소에서 겪은 일이 전무하기 때문에 잠시 공간 속에 방치된다. 그에게는 다시 재생할만한 비디오테이프가 없었다. 꿈의 주인이 꿈 속 서사를 전개해야만 함께 겪는다.
<br>
<br>
꿈의 속성이 개인적인 서사와 가까울수록, <span class="sound_text_visited" :class="{'sound-text' : visited[34] === 'disabled'}" @click="play('침대')">닫힌 문으로 만들어진 침대</span>처럼 보편 지식으로는 영 낯선 배경 속에 존재하기도 한다. 그 얘기를 들었을 때는 머리로 상상이 안 되어서 이리에가 친히 칠판에 그려줬다. 아기침대처럼 사방이 막혀있는데, 모든 면이 ‘닫힌 문’으로 만들어진 침대. 그리고 그 공간은 이리에가 모종의 법칙을 발견한 첫 번째 장소이기도 하다.
<br>
<br>
“그런데 어떻게 남의 꿈인 걸 확신해?”
<br>
<br>
“남의 꿈에서는 뭘 마음대로 열면 바닥이 만들어지지 않고 <span class="sound_text_visited" :class="{'sound-text' : visited[35] === 'disabled'}" @click="play('추락')">추락해</span>. 그 너머는 나에게 정보가 없는 영역이라서.”
<br>
<br>
이 법칙을 몰랐을 때는 꿈속에서 <span class="sound_text_visited" :class="{'sound-text' : visited[36] === 'disabled'}" @click="play('다음')">죽은 채로도 그 다음이 보였다</span>. 이리에는 그 순간 꿈속에 갇힐까봐 진심으로 섬뜩해졌다. 걔는 관에 갇힌 채로 그 뚜껑을 밀었다. 그러자 꿈의 법칙은 물리 법칙보다 우선해서 그에게 응답해줬다. 꿈이 끝났다.
<br>
<br>
이리에는 이제 꿈에서 깨고 싶거든 <span class="sound_text_visited" :class="{'sound-text' : visited[37] === 'disabled'}" @click="play('닫힌')">닫힌 문</span>을 연다. 엘리베이터의 문을 열고, 가정집의 화장실이나 침실로 보이는 문을 열고, 가끔은 냉장고도 연다. 그럼 그 안에는 아무것도 없다. 공간이 비어있다는 것이 아니라, 물리적인 의미로 텅 비어있다. 구멍이 나듯이. 그리고 꿈은 순식간에 그 안으로 허물어지기 시작한다.
<br>
<br>
어떤 꿈은 추락할 때 곤두박질치듯이 공포스럽고, 또 어떤 꿈은 그렇지 않다. 김이리에는 후자의 꿈이 가장 인상 깊었다고 말한다. 
<br>
<br>
문을 열자 아래로 떨어지고 가라앉는다. “괜찮아, 이건 꿈이야.” 오히려 현실보다 다정하다. 달콤하고 부드럽다. 아름답고 매혹적이다. 외롭지 않으며 안겨있다. <span class="sound_text_visited" :class="{'sound-text' : visited[38] === 'disabled'}" @click="play('포근')">포근히</span>. 이 사람은 꿈속의 침입자마저도 환대를 해주는군. 김이리에는 느리게 밑으로 잠기면서 눈을 감는다.
<br>
<br>
“꿈이 전염되기 전에는 무슨 꿈을 꿨어?”
<br>
<br>
“개인적인 꿈.”
<br>
<br>
“개인적인 꿈의 반대말은 뭔데?”
<br>
<br>
“사회적인 꿈.”
<br>
<br>
김이리에는 대답하고 싶지 않을 때 말장난을 한다. 그럼 나도 그쯤에서 물러난다. 말없이 한참 그네 삐거덕거리는 소리가 났다. 지금 이 장소에서 깨어나려면 어디를 열어야 할까? 생각하며 눈앞을 봤다. 운동장은 탁 트여 있었고, 그래서 장소로서는 갇혀 있었다.
<br>
<br>
<br>
<br>

사람이 아무도 없는 운동장은 <span class="sound_text_visited" :class="{'sound-text' : visited[39] === 'disabled'}" @click="play('사막')">사막</span>의 광활함을 닮았다. 비어있을 수밖에 없는 공간이 쓸쓸하면서도 마음에 들었다. 무언가를 아름답다고 느끼는 것은 슬픔으로 남는다. 아름답다는 말을 주려면 비일상이 있어야하고, 마비된 것 같은 생활의 권태로움이 일순간 아득할 정도의 압도와 비애가 따르기 마련이다. 그런 건 너무 순간의 간극이 넓다. 문득 창문을 향해 고개를 들었을 때, 잠기는 노을과 마주보는 것처럼 눈부시고 먹먹한 것. 
<br>
<br>
“하늘이 슬플 만큼 아름답네. 저런 것 앞에서는 일상이 하찮아.”
<br>
<br>
“아름다우면 아름다운 거지.”
<br>
<br>
“그러면 다음으로 볼품없는 일을 겪을 때의 낙차가 크잖아.”
<br>
<br>
“추락하지 않아. 남의 꿈에 있는 게 아니니까.”
<br>
<br>
이리에의 목소리는 그의 그네가 그리는 곡선을 따라 휘어져서 지나갔다. 걔가 공중에서 두 손을 놓았다. 중심을 잡으며 바닥으로 뛰어내렸다. 휘청거리며 앞으로 기울었다가 팔을 벌리며 척추를 곧게 세웠다. 그가 뒤를 돌아서 나를 봤다. 
<br>
<br>
“이렇게 착지할 수 있어.”
<br>
<br>
“너 그러다가 이빨 깨진다.”
<br>
<br>
그네를 타다가 무릎 다친 초등학생 때 친구를 떠올리며 말해줬다. <span class="sound_text_visited" :class="{'sound-text' : visited[40] === 'disabled'}" @click="play('딱지')">딱지</span>가 오래 갔다. 걔는 수업시간에 맨날 그걸 만지작거리며 가장자리를 긁고 있었다.
<br>
<br>
“감정의 기준을 슬픔에 두지 마.”
<br>
<br>
슬픔 외의 단위로 감정을 파악하는 것, 그러려면 그건 슬픔만큼 알아채기 쉬워야 한다. 슬픔만큼 곁을 맴돌아야 한다. 슬픔만큼 명확하고, 슬픔만큼 혼자 영위할 수 있어야 하고, 슬픔보다도 자비 없이 나를 삼켜야 한다. 
<br>
<br>
하지만 다른 감정들에게 슬픔을 능가하라 요구하는 것은, 결국 삶에 대한 투정을 에두르고 있음에 지나지 않는다는 걸 안다. 그런 시험에 들게 하면 결국 살아남는 감정은 아무도 없을 것이다. 그럼 누가 좋지? 슬픔만 좋지. 난 말야, 너만 살아남게 할 생각은 전혀 없어. 나는 발을 구르며 천천히 그네의 속력을 줄였다. 그리고 바닥을 디뎠다.
<br>
<br>
            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";

export default {
  name: 'index_eleven',
  data() {
    return {
        visited : {
            32: store.getters['getMusicIconUsable'](32),
            33: store.getters['getMusicIconUsable'](33), 
            34: store.getters['getMusicIconUsable'](34),
            35: store.getters['getMusicIconUsable'](35),
            36: store.getters['getMusicIconUsable'](36),
            37: store.getters['getMusicIconUsable'](37),
            38: store.getters['getMusicIconUsable'](38),
            39: store.getters['getMusicIconUsable'](39),
            40: store.getters['getMusicIconUsable'](40),
        },
        
    }
  },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '저수지' :      
                store.commit("toggleText", 32)
                eventBus.$emit("iconUsable", 32); 
                this.visited[32] = 'active';
                break; 
            case "엘리베이터" :
                store.commit("toggleText", 33)
                eventBus.$emit("iconUsable", 33); 
                this.visited[33] = 'active';
                break;
            case "침대" :
                store.commit("toggleText", 34)
                eventBus.$emit("iconUsable", 34); 
                this.visited[34] = 'active';
                break;
            case "추락" :
                store.commit("toggleText", 35)
                eventBus.$emit("iconUsable", 35); 
                this.visited[35] = 'active';
                break;
            case "다음" :
                store.commit("toggleText", 36)
                eventBus.$emit("iconUsable", 36); 
                this.visited[36] = 'active';
                break;
            case "닫힌" :
                store.commit("toggleText", 37)
                eventBus.$emit("iconUsable", 37); 
                this.visited[37] = 'active';
                break;
            case "포근" :
                store.commit("toggleText", 38)
                eventBus.$emit("iconUsable", 38); 
                this.visited[38] = 'active';
                break;
            case "사막" :
                store.commit("toggleText", 39)
                eventBus.$emit("iconUsable", 39); 
                this.visited[39] = 'active';
                break;
            case "딱지" :
                store.commit("toggleText", 40)
                eventBus.$emit("iconUsable", 40); 
                this.visited[40] = 'active';
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 506px;
  top: 600px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}

.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}

@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>
